import React, {Component} from 'react';
import bus from './bus';
import Ajax from './ajax';

class BindEmail extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.sendMail = this.sendMail.bind(this);
    }

    submit(event) {
        event.preventDefault();
        if (this.code.value.length != 4) {
            alert('请输入完整的验证码');
        } else {
            Ajax.post('bind', {code: this.code.value}, function (response) {
                if (response.result) {
                    bus.emit('result', response);
                }
            });
        }
    }

    sendMail() {
        if (this.email.value.length > 0) {
            Ajax.post('email', {email: this.email.value}, function (callback) {
                if (callback.result) {
                    alert('验证码发送成功');
                }
            });
        } else {
            alert('请输入邮箱地址');
        }
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <div className="weui-cells weui-cells_form">
                    <div className="weui-cell weui-cell_vcode">
                        <div className="weui-cell__hd">
                            <label className="weui-label">邮箱地址</label>
                        </div>
                        <div className="weui-cell__bd">
                            <input ref={(email) => this.email = email} className="weui-input" type="email" placeholder="请输入邮箱地址"/>
                        </div>
                        <div className="weui-cell__ft">
                            <button className="weui-vcode-btn" type="button" onClick={this.sendMail}>获取验证码</button>
                        </div>
                    </div>
                    <div className="weui-cell">
                        <div className="weui-cell__hd"><label className="weui-label">验证码</label></div>
                        <div className="weui-cell__bd">
                            <input ref={(code) => this.code = code} name="code" className="weui-input" type="number" pattern="[0-9]{4}" placeholder="请输入验证码"/>
                        </div>
                    </div>
                    <div className="weui-btn-area">
                        <input className="weui-btn weui-btn_primary" type="submit" value="提交"/>
                    </div>
                </div>
            </form>
        );
    }
}

export default BindEmail;



// WEBPACK FOOTER //
// ./src/bind-email.js